import classNames from 'classnames';
import { Button } from 'fasoo-ui-component-next';
import React, { useEffect } from 'react';

import { Trans, useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import authApi from 'src/api/auth/authApi';
import { CommonProps } from 'src/components/helpers/props';
import useAuthStore from 'src/hooks/auth/useAuthStore';
import config from 'src/shared/config';
import currentUrlUtils from 'src/shared/utils/currentUrlUtils';
import { appendLogoutCallbackEntity, getDeviceId } from 'src/shared/utils/sessionStorageManager';
import qs from 'query-string';
import AppBar from '../Layout/AppBar';

import './index.scss';
import './LoginMain.scss';
import _ from 'lodash';

const LoginMain: React.FC<CommonProps> = ({ classes }) => {
  const { t } = useTranslation(['commons']);
  const { authEntity, signIn } = useAuthStore();
  const navigate = useNavigate();

  const handleGoSignIn = (): void => {
    navigate(config.url('/sign-in'));
  };

  useEffect(() => {
    if (authEntity) {
      const contextPath = config.contextPath;
      const redirectUrl = currentUrlUtils.getFirstQuery('redirectUrl') || contextPath; // config.url('/');
      // redirect 대상이 내부 페이지면 react-router 사용, 아니면 기본 redirect 사용.
      // fast일 경우에는 임시 token을 받아서 전달
      if (redirectUrl.startsWith(contextPath)) {
        navigate(redirectUrl);
      } else if (redirectUrl.startsWith('http')) {
        const redirectToProductUrls = ['/fast'];
        const findUrl = redirectToProductUrls.find((url) => redirectUrl.includes(url));
        if (findUrl) {
          // TODO FAST인지를 판단하는 방법 좀 더 nice하게는...
          // FAST는 로그아웃 url 등록하고, 임시 토큰 받아서 redirect
          const now = Date.now();
          authApi
            .sessionInit({
              userId: authEntity.tokenEntity.userInfo.userId,
              deviceId: getDeviceId(),
              timestamp: now,
              url: redirectUrl,
            })
            .then(({ timestamp, url }) => {
              if (now === timestamp) {
                // 추후 로그아웃 시 호출할 callback url을 저장
                const logoutUrl = currentUrlUtils.getFirstQuery('logoutUrl');
                const { bearer: bearerValues } = qs.parseUrl(url).query;
                const bearer = Array.isArray(bearerValues) ? _.head(bearerValues) : bearerValues;
                if (logoutUrl && bearer) {
                  appendLogoutCallbackEntity({
                    logoutUrl,
                    token: bearer,
                  });
                }
                currentUrlUtils.setHref(url);
                // console.log('LoginOutside');
                // console.log(url);
              } else {
                // TODO error handling
                console.log(
                  `Invalid response of session init! (timestamp: ${timestamp}, now: ${now})`
                );
                navigate(config.url('/'));
              }
            })
            .catch((e) => {
              navigate(config.url('/'));
              alert(e);
            });
        }
      } else {
        currentUrlUtils.setHref(redirectUrl);
      }
    }
  }, [authEntity, navigate]);

  return (
    <div className="mfxm-login-root">
      <AppBar />
      <div className="main-page-root">
        <div className={classNames('illust-img')} />
        <div className="main-page__title">
          <Trans i18nKey={'commons:main:title'} />
        </div>
        <div className="main-page__description">
          <Trans i18nKey={'commons:main:description'} />
        </div>
        <Button classes="main-page-login__button" onClick={() => handleGoSignIn()}>
          {t('commons:main:goToLogin')}
        </Button>
      </div>
    </div>
  );
};

export default LoginMain;
